import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './selfSignUpFeedback.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type SelfSignUpFeedbackSubscription_selfSignUpFeedback_SelfSignUpFeedbackReturn = {
  __typename?: 'SelfSignUpFeedbackReturn',
  event: Types.SelfSignUpFeedbackEventEnum,
  success: boolean,
  message?: string | null
};

export type SelfSignUpFeedbackSubscription_Subscription = {
  __typename?: 'Subscription',
  selfSignUpFeedback?: SelfSignUpFeedbackSubscription_selfSignUpFeedback_SelfSignUpFeedbackReturn | null
};


export type SelfSignUpFeedbackSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type SelfSignUpFeedbackSubscription = SelfSignUpFeedbackSubscription_Subscription;


export const SelfSignUpFeedbackDocument = /*#__PURE__*/ document as unknown as DocumentNode<SelfSignUpFeedbackSubscription, SelfSignUpFeedbackSubscriptionVariables>;


/**
 * __useSelfSignUpFeedbackSubscription__
 *
 * To run a query within a React component, call `useSelfSignUpFeedbackSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSelfSignUpFeedbackSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfSignUpFeedbackSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSelfSignUpFeedbackSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<SelfSignUpFeedbackSubscription, SelfSignUpFeedbackSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<SelfSignUpFeedbackSubscription, SelfSignUpFeedbackSubscriptionVariables>(SelfSignUpFeedbackDocument, options);
      }
export type SelfSignUpFeedbackSubscriptionHookResult = ReturnType<typeof useSelfSignUpFeedbackSubscription>;
export type SelfSignUpFeedbackSubscriptionResult = ApolloReactCommon.SubscriptionResult<SelfSignUpFeedbackSubscription>;